import React from 'react';
import './privacy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1 className="privacy-title">
          Privacy Policy for Dawami
        </h1>
        <div className="privacy-card">
          <p className="privacy-effective-date">
            Effective Date: June 13, 2025
          </p>
          
          <section className="privacy-section">
            <h2 className="privacy-section-title">Introduction</h2>
            <p className="privacy-text">
              Welcome toDawami ("we," "us," or "our"). This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our mobile application ("App"). We are committed to protecting your privacy and ensuring your personal information is handled responsibly.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">Information We Collect</h2>
            <p className="privacy-text">We may collect the following types of information:</p>
            <ul className="privacy-list">
              <li><strong>Personal Information:</strong> Name, email address, phone number, and other information you provide when registering or contacting us.</li>
              <li><strong>Usage Data:</strong> Information about how you use the App, such as features accessed, time spent, and interactions.</li>
              <li><strong>Device Information:</strong> Device type, operating system, unique device identifiers, and IP address.</li>
              <li><strong>Location Data:</strong> Approximate location based on IP address or precise location if you grant permission.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">How We Use Your Information</h2>
            <p className="privacy-text">We use your information to:</p>
            <ul className="privacy-list">
              <li>Provide and improve the App's functionality.</li>
              <li>Personalize your experience and offer tailored content.</li>
              <li>Communicate with you, including sending updates or promotional offers.</li>
              <li>Analyze usage patterns to enhance our services.</li>
              <li>Comply with legal obligations and protect our rights.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">Sharing Your Information</h2>
            <p className="privacy-text">We may share your information with:</p>
            <ul className="privacy-list">
              <li><strong>Service Providers:</strong> Third parties that assist with App operations, such as analytics or hosting services.</li>
              <li><strong>Legal Authorities:</strong> When required by law or to protect our rights and safety.</li>
              <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets.</li>
            </ul>
            <p className="privacy-text">We do not sell your personal information to third parties.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">Your Choices and Rights</h2>
            <p className="privacy-text">You have the following rights regarding your information:</p>
            <ul className="privacy-list">
              <li><strong>Access:</strong> Request a copy of your personal information.</li>
              <li><strong>Correction:</strong> Update or correct inaccurate information.</li>
              <li><strong>Deletion:</strong> Request deletion of your personal information, subject to legal obligations.</li>
              <li><strong>Opt-Out:</strong> Unsubscribe from marketing communications or disable location tracking in your device settings.</li>
            </ul>
            <p className="privacy-text">
              To exercise these rights, contact us at <a href="mailto:support@dawami.com" className="privacy-link">support@dawami.com</a>.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">Data Security</h2>
            <p className="privacy-text">
              We implement reasonable security measures to protect your information from unauthorized access, use, or disclosure. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">Children's Privacy</h2>
            <p className="privacy-text">
              The App is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13. If we become aware of such data, we will take steps to delete it.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">International Data Transfers</h2>
            <p className="privacy-text">
              Your information may be transferred to and processed in countries other than your own, where data protection laws may differ. We ensure appropriate safeguards are in place for such transfers.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">Changes to This Privacy Policy</h2>
            <p className="privacy-text">
              We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the updated policy in the App or via email. Your continued use of the App after such changes constitutes acceptance of the updated policy.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">Contact Us</h2>
            <p className="privacy-text">
              If you have questions or concerns about this Privacy Policy, please contact us at:
              <br />
              Email: <a href="mailto:support@dawami.com" className="privacy-link">support@dawami.com</a>
              <br />
              Address:Dawami, 123 Main Street, Anytown, USA
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;